import * as Yup from 'yup';

const validationSchema = Yup.object({
    turf_name: Yup.string()
        .trim()
        .max(50, 'Must be 50 characters or less')
        .required('Court name is required'),

    sports_type: Yup.array()
        .of(
            Yup.string().required('Sports type is required')
        )
        .min(1, 'At least one sports type is required')
});

export default validationSchema;